import React from 'react'
import { Button } from '@/atoms/Button'
import { SceneIcon } from '@/atoms/Icons/SceneIcon'
import { AsH2, AsP, CaptionMD, CaptionSM, TitleLG } from '@/atoms/Text'
import { slugs } from '@/constants'
import { PayItForwardButton } from '@/molecules/PayItForwardButton'
import { ClaimResponse } from '@/organisms/ClaimCollectibleButton/ClaimMutation'
import { ClaimNotifications } from '@/organisms/ClaimCollectibleButton/ClaimNotifications'
import { useUserFinancials } from '@/services/UserService'
import { useSafeAnalytics } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'

interface ClaimConfirmationProps {
  onClose: () => void
  data?: ClaimResponse | null
}

export const ClaimConfirmation: React.FC<ClaimConfirmationProps> = ({ onClose, data }) => {
  const { t } = useTranslate('livestream')
  const { track } = useSafeAnalytics()
  const { userFinancials } = useUserFinancials()

  const isChosenInvestor = userFinancials?.profile?.isChosenInvestor ?? data?.profile?.isChosenInvestor
  const isChosenSubscriber = userFinancials?.profile?.isChosenSubscriber ?? data?.profile?.isChosenSubscriber
  const isChosenPiffer = userFinancials?.profile?.isChosenPiffer ?? data?.profile?.isChosenPiffer

  const numberOfScenesReserved = [isChosenInvestor, isChosenSubscriber, isChosenPiffer].filter(Boolean).length

  return (
    <div className="text-center">
      <TitleLG as={AsH2} className="mb-4">
        {t('yourSceneIsReserved', {
          count: numberOfScenesReserved,
          defaultValue: 'Your Scene is reserved!',
          defaultValue_other: 'Your Scenes are reserved!',
        })}
      </TitleLG>

      <CaptionMD className="text-gray-500">
        Here are your thank you gifts for joining the Season 3 Finale livestream.
      </CaptionMD>
      <ClaimNotifications
        isChosenSubscriber={isChosenSubscriber}
        isChosenPiffer={isChosenPiffer}
        isChosenInvestor={isChosenInvestor}
      />
      {!isChosenSubscriber && (
        <CaptionMD className="mt-8 text-gray-500">
          You could still qualify for a{' '}
          <SceneIcon className="inline" color1="gray-950" color2="collectible-gold" size={20} />{' '}
          <span className="text-collectible-gold"> Golden Scene</span> if you start Paying it Forward monthly during the
          finale.
        </CaptionMD>
      )}
      <CaptionSM as={AsP} className="my-8 text-gray-500">
        Scenes will be distributed in May at our Illuminate 2023 Event.
      </CaptionSM>
      <div className="flex justify-end gap-4">
        <Button variant="gray-900" className="justify-center" onClick={onClose}>
          Close
        </Button>
        {!isChosenSubscriber && (
          <PayItForwardButton
            projectSlug={slugs.theChosen}
            target="_blank"
            onClick={() => {
              track('Clicked Pay It Forward From Claim Confirmation')
            }}
          />
        )}
      </div>
    </div>
  )
}
